// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"eed73cd9","415":"6b11b517","565":"b0e8c6ce","832":"68544955","889":"9da59751","952":"825a9acc"}[chunkId] + ".chunk.js";
};